<template>
  <div class="container-fluid">
    <div class="row">
      <div class="fondo_menu" v-bind:class="{fondoMenuScroll: scrolled}" @scroll="handleScroll">
        <!-- <img class="logo" v-bind:src="imageLink.src" alt="" v-bind:class="{logoScroll: scrolled}"> -->
        <img class="logo" src="../assets/logo_intqd.png" alt="" v-bind:class="{logoScroll: scrolled}">

        <nav class="menuOpener" v-bind:class="{menuOpenerActive: isActive, menuOpenerScroll: scrolled}" @click="toggle">
          <div class="menuOpenerInner" v-bind:class="{menuOpenerInnerActive: whenClicked, menuOpenerInnerScroll: scrolled, black:scrolled}"></div>
        </nav>
      </div>
      <nav class="menu" v-bind:class="{menuActive: isActive, menuScroll: scrolled}" style="z-index:999999;">
        <ul class="menuInner">
          <a href="#inicio" class="menuLink" v-bind:class="{menuLinkScroll: scrolled}">
            <li>HOME</li>
          </a>
          <a href="#aboutUs" class="menuLink" v-bind:class="{menuLinkScroll: scrolled}">
            <li>ABOUT US</li>
          </a>
          <a href="#services" class="menuLink" v-bind:class="{menuLinkScroll: scrolled}">
            <li>SERVICES</li>
          </a>
          <a href="#projects" class="menuLink" v-bind:class="{menuLinkScroll: scrolled}">
            <li>PROJECTS</li>
          </a>
          <a href="#contact" class="menuLink" v-bind:class="{menuLinkScroll: scrolled}">
            <li>CONTACT</li>
          </a>
        </ul>
      </nav>

    </div>
  </div>
</template>

<script>
export default {
  name: 'menu2',
  data() {
    return {
      isActive: false,
      whenClicked: false,
      scrolled: false,
      imageLink: [{
        src: require('../assets/logo_intqd.png')
      }]
    }
  },
  methods: {
    toggle: function() {
      // console.log('Si Entre');
      this.isActive = !this.isActive;
      this.whenClicked = !this.whenClicked;
    },
    handleScroll() {
      this.scrolled = window.scrollY < 500;
      console.log('hola');
      this.scrolled = !this.scrolled;
    },
    handleDocumentClick() {
                    // console.log('Entro0o0o0o0')
      $(document).ready(function() {
        $(document).click(function(event) {
          var clickover = $(event.target)
          var opened = $('.menu').hasClass('menuActive')
          console.log(opened)
           console.log(clickover)
          if (opened === true && !clickover.hasClass('menuOpenerInner')) {
            //Esto si abre y cierra el menu 
            $('.menuOpenerInner').click()
          }
        })
      })
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function(){
    this.handleDocumentClick()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  position: fixed;
  top: 5%;
  left: 9%;
  z-index: 5;
}

.navbar {
  background-color: transparent !important;
  border-color: transparent !important;
}


*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.menuOpener,
.menuOpener:hover,
.menuOpenerActive,
.menuOpenerInner,
.menuOpenerInner::before,
.menuOpenerInner::after,
.menu,
.menuActive,
.logoScroll,
.fondoMenuScroll {
  -webkit-transition: 250ms all;
  transition: 250ms all;
}

.menuOpener {
  cursor: pointer;
  height: 50px;
  position: fixed;
  top: 4.5%;
  right: 9%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 64px;
  z-index: 99999;
  /* border: 1px solid red !important; */
}


.fondoMenuScroll {
  width: 100%;
  background-color: #333434 !important;
  height: 75px;
  position: fixed;
  z-index: 1;
}

.menuOpenerInnerScroll {
  background: #fff !important;
}

.menuOpenerScroll {
  top: 2% !important;
}

.logoScroll {
  top: 2%;
  /* background-image: url("../assets/logo_intqd2.png") !important; */
}

.menuOpenerHover,
.menuOpenerActive {
  -webkit-transition: 250ms all;
  transition: 250ms all;
}

.menuOpenerInner {
  background: #fff;
  height: .5rem;
  margin-right: .75rem;
  margin-top: 1.75rem;
  width: 2.5rem;
}

.menuOpenerInner::before,
.menuOpenerInner::after {
  background: white;
  content: '';
  display: block;
  height: .5rem;
  width: 2.5rem;
}

.menuOpenerInner::before {
  -webkit-transform: translateY(-0.75rem);
  -ms-transform: translateY(-0.75rem);
  transform: translateY(-0.75rem);
}

.menuOpenerInner::after {
  -webkit-transform: translateY(0.25rem);
  -ms-transform: translateY(0.25rem);
  transform: translateY(0.25rem);
}

.menuOpenerInnerActive {
  background: transparent !important;
}

.menuOpenerInnerActive::before {
  -webkit-transform: translateY(0rem) rotate(-45deg);
  -ms-transform: translateY(0rem) rotate(-45deg);
  transform: translateY(0rem) rotate(-45deg);
}

.menuOpenerInnerActive::after {
  -webkit-transform: translateY(-0.5rem) translateX(0rem) rotate(45deg);
  -ms-transform: translateY(-0.5rem) translateX(0rem) rotate(45deg);
  transform: translateY(-0.5rem) translateX(0rem) rotate(45deg);
}

.menuOpenerInner.black::after,
.menuOpenerInner.black::before {
  background: #fff;
}

.menuOpenerInner.active {
  background: transparent !important;
}

.menu {
  /* background: #f86d10; */
  color: transparent;
  height: 50px;
  position: fixed;
  top: 4%;
  right: 9%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 0rem;
  z-index: 1;
}

.menuScroll {
  background: transparent;
  top: 1.7%;
}

.menuLinkScroll {
  color: #fff !important;
  top: 3% !important;
}

.menuActive {
  width: -webkit-calc(70% - 2rem);
  width: calc(70% - 2rem);
  /* width: 100%; */
  left: 280px;
}

.menuActive .menuLink {
  color: white;
}

.menuInner {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  height: 100%;
  list-style-type: none;
  margin: 0;
  margin-left: 4rem;
  padding: 0;
}

.menuLink {
  color: transparent;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 11pt;
  font-weight: 100;
  height: 100%;
  text-align: center;
  text-decoration: none;
  margin: auto 0px auto 0px;
}

.menuLink li {
  margin: auto;
  margin: auto 60px auto 135px;
  z-index: 3;
  white-space: nowrap;
  font-weight: 800;
}

@media screen and (max-width: 1450px) {
  .menuActive .menuLink {
    color: white;
    margin-left: -50px !important;
  }
  .menuLink li {
    margin: auto 10px auto 140px !important;
  }

  .menuActive {
    width: -webkit-calc(60% - 2rem);
    width: calc(60% - 2rem);
    /* width: 100%; */
    left: 280px;
  }
}

/*tablet horizontal */
@media screen and (max-width:1025px){
  .menuLink li {
  margin: auto 60px auto 65px !important;
}

  .menuActive{
        left: 160px !important;
  }
  
}

@media screen and (max-width: 768px) {
  .menu {
    /* height: 80px;
      background: #f86d10;
        top: 0%;
  right: 0%;
  width: 100%; */
    /* display: none; */
      right: 0%;
              top: 10%;
  }
  .menuInner {
    display: block;
    /* display: none; */
  }
  .menuLink {
    padding: 10px 0;
    font-size: 1.2em;
    /* display: none; */
  }
  .menuActive {
    width: -webkit-calc(100% - 0.5rem);
    width: calc(100% - 0.5rem);
    left: 0px !important;
    /* display: none; */
    height: auto;
    width: 100vw;
    background-color: #333434;
    z-index: 3;
  }

  .menuOpener{
    right: 0%;
  }

  .menuOpener,
  .menuOpenerInner,
  .menuOpenerInnerActive {
    display: block;
  }

  .menuActive .menuLink,
  .fondoMenuScroll {
    display: block;
  }

  li{
   color: white !important
  }

  .fondoMenuScroll {
  width: 100%;
  background-color: #333434 !important;
  height: 75px;
  position: fixed;
  z-index: 3;
}

}












/* tablet */

@media screen and (max-width: 991px) {}













/* mobile */

@media screen and (max-width: 767px) {
  .container-fluid {
    background-size: unset;
  }

  hr {
    display: none;
  }

  h2 {
    margin: 0px;
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue